import type { AppData } from '../../types/app_data';
import { StepCategory } from '../../types/app_data';
import type { Step } from '../types/step';

/**
 * Garage cross-sell step
 */
export const GarageStep: Step = {
  id: 'garage',
  pathname: '/garage',
  canShow: (appData: AppData): boolean => {
    // skip if garage is already selected in service split
    if (appData.serviceSplitSelectedService?.garage) {
      return false;
    }
    if (appData.signupParams?.needNNOInsurance === true) {
      return false;
    }
    return true;
  },
  hasData: () => true,
  hasOwnData: () => true,
  category: () => StepCategory.Other,
};
